<template>
    <div :data-cy="$attrs['data-cy'] || 'input_label_dropdown'">
        <div class="text-sm" :class="[isError ? 'text-red-500' : 'text-gray-800']" data-cy="text_dropdown_name">
            {{inputLbl.name}}
        </div>
        <div class="relative pb-5" ref="dropdown-btn">
            <!-- Dropdown btn -->
            <button class="w-full bg-white px-3 py-1 placeholder-gray-500"
                    :class="[isError ? 'border border-red-500' : 'border']"
                    @click="toggleDropdown()"
                    data-cy="btn_dropdown_toggle">
                <span v-if="itemSelected == null" :class="[isError ? 'text-red-500' : '']" data-cy="text_dropdown_placeholder">
                    {{inputLbl.placeholder}}
                </span>
                <span v-else data-cy="text_dropdown_selected">{{itemSelected.text}}</span>
            </button>
            <!-- item list -->
            <div v-show="showList && itemList.length > 0"
                 ref="ddl-list-area"
                 class="absolute left-0 w-full bg-white border rounded-md overflow-hidden z-index-dropdown"
                 :class="[isBottomDropdown ? 'top-10' : 'bottom-16']"
                 data-cy="list_dropdown_items">
                <div class="max-h-64 overflow-y-auto hide-scroll">
                    <div v-for="(v) in itemList" :key="v.value"
                        class="py-2 px-4 border-b last:border-b-0 cursor-pointer hover:bg-gray-50 text-center"
                        @click="selectItem(v)"
                        :data-cy="`card_dropdown_item_${v.value}`">
                        {{v.text}}
                    </div>
                </div>
            </div>
            <!-- error msg -->
            <div class="text-red-500 text-sm absolute bottom-0 left-0" v-if="isError" data-cy="text_dropdown_error">
                {{getErrorMsg}}
            </div>
        </div>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Array} itemList (required) list of dropdown item { key: '', value: '' }
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputDropdown",
    props: {
        // v-model
        inputValue:     { type: [String,Number] },
        itemList:       { type: Array, required: true },
        // props
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },
    },
    data: function() {
        return {
            content: this.inputValue,
            showList: false,
            itemSelected: null,

            isBottomDropdown: true,
        };
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid) 
                ? this.errorInfo.msg
                : '';
        }
    },
    mounted: function() {
        this.setSelectedDropdown();
        this.validateInput();
    },
    methods: {
        setSelectedDropdown: function() {
            let item = this.itemList.find((obj) => {
                return obj.value == this.content;
            });
            if (item != null) {
                this.itemSelected = item;
            }
        },

        toggleDropdown: function() {
            if (this.showList) {
                this.closeDropdown();
            } else {
                this.openDropdown();
            }
        },
        openDropdown: function() {
            this.isBottomDropdown = true;
            this.showList = true;
            document.addEventListener('click', this.documentClick);

            this.$nextTick(() => {
                let elem = this.$refs['ddl-list-area'];
                let bottom = elem.getBoundingClientRect().bottom;
                let windowHeight = window.innerHeight;

                this.isBottomDropdown = bottom < windowHeight;
            });
        },
        closeDropdown: function() {
            this.showList = false;
            document.removeEventListener('click', this.documentClick);
        },
        documentClick: function(e) {
            let el = this.$refs['dropdown-btn'];
            var target = e.target;

			if (el !== target && !el.contains(target)) {
				this.closeDropdown();
			}
        },

        selectItem: function(item) {
            this.content = item.value;
            this.itemSelected = item;
            this.closeDropdown();

            this.validateInput();
            this.$emit('update:inputValue', this.content);
        },

        clearSelect: function() {
            this.content = "";
            this.itemSelected = null;
            this.closeDropdown();

            this.validateInput();
            this.$emit('update:inputValue', this.content);
        },

        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && this.itemSelected == null) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
        },
        setValue: function(value) {
            this.content = value;
            this.setSelectedDropdown();
            this.validateInput();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
</style>
